import { MAJOR_ASPECTS } from './constants.js';
import { enrichPlanetList, shortestAngularDistance } from './utils.js';

export function calculateAspects({
  source = [],
  target = [],
  aspects = MAJOR_ASPECTS,
  sourceType = 'transit',
  targetType = 'natal',
  includeSameBody = true,
} = {}) {
  const sourcePlanets = enrichPlanetList(source);
  const targetPlanets = enrichPlanetList(target);
  const results = [];

  for (const from of sourcePlanets) {
    for (const to of targetPlanets) {
      if (!includeSameBody && from.id === to.id) continue;
      const separation = shortestAngularDistance(from.longitude, to.longitude);
      for (const aspect of aspects) {
        const delta = Math.abs(separation - aspect.angle);
        const orb = Number(aspect.orb ?? 0);
        if (delta <= orb) {
          results.push({
            id: `${sourceType}:${from.id}-${targetType}:${to.id}-${aspect.id}`,
            type: aspect.id,
            label: aspect.label,
            angle: aspect.angle,
            orb: delta,
            separation,
            sourceType,
            targetType,
            from,
            to,
            applying: inferApplying(from, to, aspect.angle),
          });
          break;
        }
      }
    }
  }

  return results.sort((a, b) => a.orb - b.orb);
}

function inferApplying(from, to, exactAngle) {
  if (!Number.isFinite(from.speed) || !Number.isFinite(to.speed)) return null;
  const now = shortestAngularDistance(from.longitude, to.longitude);
  const later = shortestAngularDistance(
    from.longitude + from.speed * 0.01,
    to.longitude + to.speed * 0.01,
  );
  return Math.abs(later - exactAngle) < Math.abs(now - exactAngle);
}
